import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { ErrorMessage, Field, Form as FormFormik, useFormikContext } from 'formik';

const EnvioDeAceiteForm = ({ fecharModal }) => {
    const { errors, values, setFieldValue } = useFormikContext();

    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);

    useEffect(() => {
        const errorsKeys = Object.keys(errors);

        if ((values.FormaEnvio === 1 || values.FormaEnvio === 3) && errorsKeys.includes('TelefoneEnvio')) {
            setSubmitButtonDisabled(true);

            return;
        } else if (values.FormaEnvio === 2 && errorsKeys.includes('EmailEnvio')) {
            setSubmitButtonDisabled(true);

            return;
        }

        setSubmitButtonDisabled(false);
    }, [errors, values.FormaEnvio]);

    return (
        <FormFormik className="p-col-12 p-md-12 p-lg-12 p-sm-12">
            <Fieldset className='legend-field-set' legend="Envio">
                <div className="p-field p-grid">
                    <h2 className="p-col-12 p-md-12 p-lg-12 p-sm-12 titulo-forma-envio">Formas de Envio</h2>
                    <div className="p-field-checkbox p-col-12 p-md-4 p-lg-4 p-sm-12 mt-2">
                        <Field
                            as={RadioButton}
                            inputId="tipoEmail"
                            name="FormaEnvio"
                            value={2}
                            onChange={e => setFieldValue('FormaEnvio', e.value)}
                            checked={values.FormaEnvio === 2}
                        />
                        <label className='nome-radio-buttons' htmlFor="tipoEmail">Email</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-4 p-lg-4 p-sm-12">
                        <Field
                            as={RadioButton}
                            inputId="tipoWhats"
                            name="FormaEnvio"
                            value={3}
                            onChange={e => setFieldValue('FormaEnvio', e.value)}
                            checked={values.FormaEnvio === 3}
                        />
                        <label className='nome-radio-buttons' htmlFor="tipoWhats">Whatsapp</label>
                    </div>
                    <div className="p-field-checkbox p-col-12 p-md-4 p-lg-4 p-sm-12">
                        <Field
                            as={RadioButton}
                            inputId="tipoMsg"
                            name="FormaEnvio"
                            value={1}
                            onChange={e => setFieldValue('FormaEnvio', e.value)}
                            checked={values.FormaEnvio === 1}
                        />
                        <label className='nome-radio-buttons' htmlFor="tipoMsg">Mensagem de texto</label>
                    </div>
                </div>
                <br />
                <div className="p-grid p-fluid">
                    {values.FormaEnvio === 2 && (
                        <div className="p-col-12 p-md-8">
                            <Field
                                as={InputText}
                                value={values.EmailEnvio}
                                name="EmailEnvio"
                                id="EmailEnvio"
                                placeholder="Email"
                            />
                            <ErrorMessage
                                component="span"
                                name="EmailEnvio"
                                style={{ color: 'red' }}
                            />
                        </div>
                    )}
                    {(values.FormaEnvio === 1 || values.FormaEnvio === 3) && (
                        <div className="p-col-12 p-md-8">
                            <Field
                                type="text"
                                value={values.TelefoneEnvio}
                                as={InputMask}
                                name="TelefoneEnvio"
                                id="TelefoneEnvio"
                                maxLength="11"
                                mask="(99) 99999-9999"
                                placeholder="Numero Whatsapp ou para Msg"
                            />
                            <ErrorMessage
                                component="span"
                                name="TelefoneEnvio"
                                style={{ color: 'red' }}
                            />
                        </div>
                    )}
                </div>
            </Fieldset>
            <br />
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                    <Button
                        disabled={submitButtonDisabled}
                        type="submit"
                        label="Enviar"
                        className="p-button-success"
                    />
                </div>
                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                    <Button label="Fechar" onClick={fecharModal} />
                </div>
            </div>
        </FormFormik>
    );
};

export default EnvioDeAceiteForm;